<script >
import { defineProps } from '@vue/composition-api';
import { useQueryClient } from '@tanstack/vue-query';
import { Message } from 'element-ui';
import { default as FormEditCompany } from './form/formEditCompany';
import { default as DropdownTable } from '@/components/dropdownTable';
import { default as Alert } from '@/components/alert';
import { useModal } from '@/composable/useModal';
import getMessageError from '@/utils/getMessageError';
import { addingLoading, closeLoading } from '@/utils/handleControlLoading';
import { companyService } from '@/api/transfer/company';
import { toast } from '@/utils/programaticToast';
import { getToastContentComponent } from '@/utils/getToastContentComponent';
const __sfc_main = {};
__sfc_main.props = {
  row: {
    type: Object
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;

  /* edit base */
  const {
    isOpen: isOpenModalEdit,
    handleVisibility: handleVisibilityModalEdit
  } = useModal();
  const {
    isOpen: isOpenModalDelete,
    handleVisibility: handleVisibilityModalDelete
  } = useModal();
  const queryClient = useQueryClient();
  async function handleDelete() {
    try {
      addingLoading();
      await companyService.delete(props.row.id);
      toast.open({
        variant: 'success',
        position: 'bottom',
        component: getToastContentComponent({
          title: 'Excluído com sucesso',
          describe: 'Companhia foi excluída com sucesso',
          typeIcon: 'success'
        }),
        closable: true,
        duration: 4000
      });
      queryClient.invalidateQueries({
        queryKey: ['companies']
      });
      handleVisibilityModalDelete();
    } catch (error) {
      toast.open({
        variant: 'error',
        position: 'bottom',
        component: getToastContentComponent({
          title: 'Ocorreu um erro',
          describe: getMessageError(error),
          typeIcon: 'error'
        }),
        closable: true,
        duration: 4000
      });
    } finally {
      closeLoading();
    }
  }
  return {
    isOpenModalEdit,
    handleVisibilityModalEdit,
    isOpenModalDelete,
    handleVisibilityModalDelete,
    handleDelete
  };
};
__sfc_main.components = Object.assign({
  DropdownTable,
  FormEditCompany,
  Alert
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>
  <div>
    <DropdownTable aria-role="list">
      <o-dropdown-item aria-role="listitem" @click="handleVisibilityModalEdit">
        {{ $t('company.edit') }}
      </o-dropdown-item>

      <o-dropdown-item aria-role="listitem" @click="handleVisibilityModalDelete">
        {{ $t('company.delete') }}
      </o-dropdown-item>
    </DropdownTable>

    <o-modal :active="isOpenModalEdit" width="560" @close="handleVisibilityModalEdit">
      <div>
        <h2 class="header-2">{{ $t('company.editCompanyTitle') }}</h2>
        <p class="paragraph">`{{ $t('company.editCompanyParagraph') }}`</p>
      </div>

      <FormEditCompany :company-data="row" :close-modal="handleVisibilityModalEdit" />
    </o-modal>

    <Alert
      :active="isOpenModalDelete"
      @handleClose="handleVisibilityModalDelete"
    >
      <template #title> {{ $t('company.deleteTitle') }} </template>
      <template #message>
        {{ $t('company.deleteParagraph') }} {{ row.shipping_company_name }}
      </template>

      <template #buttons>
        <o-button variant="outline" size="md" @click="handleVisibilityModalDelete"> {{ $t('company.cancel') }} </o-button>
        <o-button variant="primary" size="md" @click="handleDelete"> {{ $t('company.yesDelete') }} </o-button>
      </template>
    </Alert>
  </div>
</template>
